// extracted by mini-css-extract-plugin
export default {"support":"styles_support__qRcey","support__text":"styles_support__text__1oCb3","support__button":"styles_support__button__dMVMf"};